import { render, staticRenderFns } from "./MasterDataServices.vue?vue&type=template&id=acf42508&scoped=true"
import script from "./MasterDataServices.vue?vue&type=script&lang=js"
export * from "./MasterDataServices.vue?vue&type=script&lang=js"
import style0 from "./MasterDataServices.vue?vue&type=style&index=0&id=acf42508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf42508",
  null
  
)

export default component.exports